import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "form",
  class: "grid grid-cols-6 gap-3 mt-5 md:gap-6 lg:mt-6"
}
const _hoisted_2 = { class: "col-span-6 pb-3 border-t border-gray-200 lg:pb-0" }
const _hoisted_3 = { class: "col-span-6 pb-3 md:pb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Perpetrator Type", -1)
const _hoisted_5 = { class: "flex items-center pt-5 space-x-6" }
const _hoisted_6 = { class: "col-span-6 pb-3 md:pb-0" }
const _hoisted_7 = {
  key: 0,
  class: "col-span-6"
}
const _hoisted_8 = {
  key: 1,
  class: "col-span-6"
}
const _hoisted_9 = {
  key: 2,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_10 = {
  key: 3,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_11 = {
  key: 4,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_12 = { class: "col-span-6 lg:col-span-2 md:col-span-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_14 = { class: "flex items-center pt-2 space-x-6 md:pt-5" }
const _hoisted_15 = { class: "col-span-6 lg:col-span-2 md:col-span-3" }
const _hoisted_16 = { class: "col-span-6 lg:col-span-2 md:col-span-3" }
const _hoisted_17 = {
  key: 5,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_18 = {
  key: 6,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_19 = {
  key: 7,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_20 = {
  key: 8,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_21 = {
  key: 9,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_22 = {
  key: 10,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_23 = {
  key: 11,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}
const _hoisted_24 = {
  key: 12,
  class: "col-span-6"
}
const _hoisted_25 = {
  key: 13,
  class: "col-span-6"
}
const _hoisted_26 = {
  key: 14,
  class: "col-span-6 lg:col-span-2 md:col-span-3"
}

import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { ref, type PropType, watch, onMounted, computed } from "vue";
import { renderSelectV2, renderSelect } from "@/interfaces/DropdownInterface";
import { PerpetratorCreate } from "@/interfaces/Cases/Perpetrator";
import { PerpetratorIdentity } from "@/views/enums/PerpetratorIdentity";
import { numberonly } from "@/components/composables/useNumberOnly";
import { useRoute } from "vue-router";

import UserBirthdateAge from '@/components/forms/UserBirthdateAge.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
	form: {
		type: Object as PropType<PerpetratorCreate>,
		required: true,
	},
	errors: {
		type: Object,
		required: true,
	},
	genders: {
		type: [] as PropType<renderSelectV2>,
		default: [],
	},
	identities: {
		type: [] as PropType<renderSelectV2>,
		default: [],
	},
	relationships: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	nationalities: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	religions: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	currentLocations: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
	item: {
		type: Object as PropType<PerpetratorCreate>,
		required: true,
	},
	isEdit: {
		type: Boolean,
		default: false,
	},
},
  setup(__props, { expose: __expose }) {

const verified = ref<boolean>(false);
const known = ref<boolean>(false);
const unknown = ref<boolean>(false);
const route = useRoute();
const birthdateForm = ref<any>(null);

const props = __props;

const form = ref<PerpetratorCreate>(props.form);
const setStaticIdentity = form.value.identity;
const identities = computed<renderSelect[]>(() =>
	props.identities.filter((item) => {
		if (route.params.perpetrator && setStaticIdentity != PerpetratorIdentity.UNKNOWN) {
			if (item.id != PerpetratorIdentity.UNKNOWN) {
				return item;
			}
		} else {
			return item;
		}
	})
);

const resetUnkownForm = () => {
	form.value.tag = props.item?.tag;
	form.value.details = props.item?.details;
	form.value.contacts = null;
};

const checkOthers = () => {
    if (form.value.other_nationality) {
        form.value.nationality_id = 'others';
    }

    if (form.value.other_religion) {
        form.value.religion_id = 'others';
    }
}

watch(
	() => form.value.identity, 
	(value) => {

	if (value == PerpetratorIdentity.KNOWN) {
		known.value = true;
		unknown.value = false;
		resetUnkownForm();
	
	}

	if (value == PerpetratorIdentity.UNKNOWN) {
		known.value = false;
		unknown.value = true;
        form.value.is_minor = false;
		resetUnkownForm();
	}
});

const identifyIdentity = () => {
	if (form.value.identity == PerpetratorIdentity.KNOWN) {
		known.value = true;
	}

	if (form.value.identity == PerpetratorIdentity.UNKNOWN) {
		unknown.value = true;
	}
};

watch(
    () => form.value.nationality_id,
    (val: any) => {
        if (val !== 'others') {
            form.value.other_nationality = null;
        }
    }
);

watch(
    () => form.value.religion_id,
    (val: any) => {
        if (val !== 'others') {
            form.value.other_religion = null;
        }
    }
);

__expose({
	form,
	birthdateForm,
})

onMounted(() => {
    checkOthers();
    console.log(form.value);
	identifyIdentity();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.errors?.message)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["text-[10px] mt-1", __props.errors?.message ? 'text-red-600' : 'text-gray-800']),
            id: "email-error"
          }, _toDisplayString(__props.errors?.message), 3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(RadioGroup, {
          id: "identity",
          options: identities.value,
          name: "type",
          modelValue: form.value.identity,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.identity) = $event)),
          error: __props.errors?.identity,
          disabled: __props.isEdit
        }, null, 8, ["options", "modelValue", "error", "disabled"])
      ]),
      (__props.errors?.identity)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["text-[10px] mt-1", __props.errors?.identity ? 'text-red-600' : 'text-gray-800']),
            id: "email-error"
          }, _toDisplayString(__props.errors?.identity), 3))
        : _createCommentVNode("", true)
    ]),
    (form.value.identity >= 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(CheckboxInput, {
              checked: form.value.is_minor,
              id: "is_minor",
              name: "is_minor",
              label: "Is Minor?",
              modelValue: form.value.is_minor,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.is_minor) = $event)),
              error: __props.errors?.is_minor
            }, null, 8, ["checked", "modelValue", "error"])
          ]),
          (unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Perpetrator Tag",
                  placeholder: "Perpetrator Tag",
                  name: "perpetrator_tag",
                  id: "tag",
                  required: "",
                  disabled: true,
                  modelValue: form.value.tag,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.tag) = $event)),
                  error: __props.errors?.tag
                }, null, 8, ["modelValue", "error"])
              ]))
            : _createCommentVNode("", true),
          (unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(TextInput, {
                  textarea: "",
                  label: "Details",
                  placeholder: "Describe perpetrator",
                  name: "details",
                  id: "details",
                  modelValue: form.value.details,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.details) = $event)),
                  error: __props.errors?.details
                }, null, 8, ["modelValue", "error"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Last Name",
                  placeholder: "Last name",
                  name: "last_name",
                  id: "last_name",
                  required: "",
                  modelValue: form.value.last_name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.last_name) = $event)),
                  error: __props.errors?.last_name,
                  disabled: __props.isEdit
                }, null, 8, ["modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "First Name",
                  placeholder: "First name",
                  name: "first_name",
                  id: "first_name",
                  required: "",
                  modelValue: form.value.first_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.first_name) = $event)),
                  error: __props.errors?.first_name,
                  disabled: __props.isEdit
                }, null, 8, ["modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Middle Name",
                  placeholder: "Middle name",
                  name: "middle_name",
                  id: "middle_name",
                  modelValue: form.value.middle_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.middle_name) = $event)),
                  error: __props.errors?.middle_name,
                  disabled: __props.isEdit
                }, null, 8, ["modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(RadioGroup, {
                id: "genders",
                name: "gender",
                options: __props.genders,
                modelValue: form.value.gender,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.gender) = $event)),
                error: __props.errors?.gender,
                required: "",
                disabled: __props.isEdit
              }, null, 8, ["options", "modelValue", "error", "disabled"])
            ]),
            (__props.errors?.gender)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(["text-[10px] mt-1", __props.errors?.gender ? 'text-red-600' : 'text-gray-800']),
                  id: "email-error"
                }, _toDisplayString(__props.errors?.gender), 3))
              : _createCommentVNode("", true)
          ]),
          _createVNode(UserBirthdateAge, {
            ref_key: "birthdateForm",
            ref: birthdateForm,
            form: form.value,
            errors: __props.errors,
            customClass: "lg:col-span-2 md:col-span-3 col-span-6"
          }, null, 8, ["form", "errors"]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(MultiSelect, {
              searchable: "",
              options: __props.relationships,
              id: "perpetrator_relationship_id",
              name: "relationship",
              label: "Relationship",
              placeholder: "Select..",
              required: "",
              modelValue: form.value.perpetrator_relationship_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.perpetrator_relationship_id) = $event)),
              error: __props.errors?.perpetrator_relationship_id,
              disabled: __props.isEdit
            }, null, 8, ["options", "modelValue", "error", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(TextInput, {
              type: "text",
              label: "Other Relationship",
              placeholder: "Other Relationship",
              name: "other_relationship",
              id: "other_relationship",
              modelValue: form.value.other_relationship,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.other_relationship) = $event)),
              error: __props.errors?.other_relationship
            }, null, 8, ["modelValue", "error"])
          ]),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Nickname",
                  placeholder: "Nickname",
                  name: "nickname",
                  id: "nickname",
                  modelValue: form.value.nickname,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.nickname) = $event)),
                  error: __props.errors?.nickname,
                  disabled: __props.isEdit
                }, null, 8, ["modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Occupation",
                  placeholder: "Occupation",
                  name: "occupation",
                  id: "occupation",
                  modelValue: form.value.occupation,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.occupation) = $event)),
                  error: __props.errors?.occupation,
                  disabled: __props.isEdit
                }, null, 8, ["modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: __props.nationalities,
                  id: "nationality_id",
                  name: "nationality",
                  label: "Nationality",
                  placeholder: "Select..",
                  modelValue: form.value.nationality_id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.nationality_id) = $event)),
                  error: __props.errors?.nationality_id,
                  disabled: __props.isEdit
                }, null, 8, ["options", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(TextInput, {
                  id: "other_nationality",
                  name: "nationality_others",
                  label: "Specify",
                  placeholder: "Select..",
                  modelValue: form.value.other_nationality,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.other_nationality) = $event)),
                  error: __props.errors?.other_nationality,
                  disabled: form.value.nationality_id != 'others' || __props.isEdit
                }, null, 8, ["modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: __props.currentLocations,
                  id: "current_location",
                  name: "current_location",
                  label: "Current Location",
                  placeholder: "Select..",
                  modelValue: form.value.current_location,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.current_location) = $event)),
                  error: __props.errors?.current_location
                }, null, 8, ["options", "modelValue", "error"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: __props.religions,
                  id: "religion_id",
                  name: "religion",
                  label: "Religion",
                  placeholder: "Select..",
                  modelValue: form.value.religion_id,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.religion_id) = $event)),
                  error: __props.errors?.religion_id,
                  disabled: __props.isEdit
                }, null, 8, ["options", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(TextInput, {
                  id: "other_religion",
                  name: "religion_others",
                  label: "Specify",
                  placeholder: "Select..",
                  disabled: form.value.religion_id != 'others' || __props.isEdit,
                  modelValue: form.value.other_religion,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.other_religion) = $event)),
                  error: __props.errors?.other_religion
                }, null, 8, ["disabled", "modelValue", "error"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(TextInput, {
                  textarea: "",
                  label: "Perpetrator's Address/Location",
                  placeholder: "Perpetrator's Address/Location",
                  name: "perpetrator_address",
                  id: "perpetrator_address",
                  textAreaRows: 1,
                  modelValue: form.value.perpetrator_location,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.perpetrator_location) = $event)),
                  error: __props.errors?.perpetrator_location
                }, null, 8, ["modelValue", "error"])
              ]))
            : _createCommentVNode("", true),
          (!unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(TextInput, {
                  textarea: "",
                  label: "Other Information About The Perpetrator",
                  placeholder: "Other Information About The Perpetrator",
                  name: "info_about_perpetrator",
                  id: "about_perpetrator",
                  textAreaRows: 1,
                  modelValue: form.value.about_perpetrator,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.about_perpetrator) = $event)),
                  error: __props.errors?.about_perpetrator
                }, null, 8, ["modelValue", "error"])
              ]))
            : _createCommentVNode("", true),
          (known.value || unknown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Contact Number",
                  placeholder: "Contact Number",
                  name: "contact_number",
                  id: "contacts",
                  add_on_left: true,
                  add_on_text: "+63",
                  maxlength: 10,
                  onKeypress: _unref(numberonly),
                  modelValue: form.value.contacts,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.contacts) = $event)),
                  error: __props.errors?.contacts,
                  disabled: __props.isEdit
                }, null, 8, ["onKeypress", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})